import { gql } from '@apollo/client';

export const EXPORT_EXIT_LEVELS_CSV = gql`
  mutation ExportExitLevelsCSV($portfolioId: ID!) {
    exportExitLevelsCSV(portfolioId: $portfolioId) {
      success
      error
      csvData
    }
  }
`;

export const IMPORT_EXIT_LEVELS_CSV = gql`
  mutation ImportExitLevelsCSV($portfolioId: ID!, $csvData: String!, $startingRow: Int) {
    importExitLevelsCSV(portfolioId: $portfolioId, csvData: $csvData, startingRow: $startingRow) {
      success
      error
      importedCount
      skippedCount
      warnings { rowNumber ticker message }
    }
  }
`;


